module.exports = __webpack_public_path__ + "static/media/leadership.496d8e6b.jpg";